import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Typography,
  Divider,
  Switch,
  Grid
} from '@material-ui/core';
import { changeHomepageCTABlockConfig } from 'redux/actions/store_configs';


const CTAGeneral: React.FC<CTAGeneralProps> = ({ values, setFieldValue }) => {
  const dispatch = useDispatch();
  const { general } = values;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, checked, type, value } = event.target;
    dispatch(changeHomepageCTABlockConfig(name, checked, type, value, 'general'));

    if (type === 'checkbox') {
      setFieldValue(`general[${name}]`, checked ? '1' : '0');
    }
  };

  return (
    <div>
      <Typography variant="h4" className="my-6 mx-3">General</Typography>
      <Divider className="mb-8" />
      <Grid container spacing={3} className="mb-4">
        <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
        <Grid item xs={12} sm={9}>
          <Switch
            color="primary"
            name="store_info/cta/is_cta_enabled"
            checked={general['store_info/cta/is_cta_enabled'] == 1}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
      <Divider className="mb-8" />
    </div>
  );
};

export default CTAGeneral;
